import React, { lazy } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Grid from '../components/Grid'
import StripeKPIs from '../components/StripeKPIs'
import StripePageTitle from '../components/StripePageTitle'
import UbliqueContainer from '../components/Container'
import StripeActiveFilters from '../components/StripeActiveFilters'
import './index.scss'

const StripeScheduler = lazy(() => import('../components/StripeScheduler'))
const StripeGantt = lazy(() => import('../components/StripeGantt'))

const PageOutputKpisGantt = ({
  title,
  className,
  stripeKpis,
  stripeGantt,
  stripeScheduler = false,
  configMenu,
  stripeModal,
  stripeKpisTitle,
  stripeKpisComponent,
  stripeActiveFilters
}) => {
  return (
    <UbliqueContainer stripeModal={stripeModal}>
      <Grid className={cn('ublique-page-output-gantt', className)}>
        {title && <StripePageTitle text={title} configMenu={configMenu} />}
        {stripeActiveFilters && (
          <StripeActiveFilters filterProps={stripeActiveFilters} />
        )}
        {stripeKpis && (
          <StripeKPIs
            kpis={stripeKpis}
            stripeKpisTitle={stripeKpisTitle}
            stripeKpisComponent={stripeKpisComponent}
          />
        )}
        {stripeGantt && <StripeGantt gantt={stripeGantt} />}
        {stripeScheduler && <StripeScheduler scheduler={stripeScheduler} />}
      </Grid>
    </UbliqueContainer>
  )
}

PageOutputKpisGantt.propTypes = {
  // da sistemare con Yup
  title: PropTypes.string,
  stripeKpis: PropTypes.array,
  stripeTables: PropTypes.array,
  stripeModal: PropTypes.object,
  configMenu: PropTypes.object,
  stripeGantt: PropTypes.object,
  stripeScheduler: PropTypes.object,
  stripeActiveFilters: PropTypes.object
}

export default PageOutputKpisGantt
